import React, { useEffect, useState } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { apiCall } from '../../../action/RouterActions';

import { tableExportOptions } from '../../helpers/table';
import momenttz from '../../helpers/momenttz';
import CustomButton from '../../CustomButton';

const Migration = (props) => {
    const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.migration' });
    const { company, toggleLoader } = props;

    const [data, setData] = useState([]);
    const [selectRow, setSelectRow] = useState([]);
    const [showDevicesModal, setShowDevicesModal] = useState(false);

    useEffect(() => {
        getDevicesMigration();
    }, [company.company_id]);

    const getDevicesMigration = () => {
        toggleLoader(true);
        apiCall('GET', `/companies/${company.company_id}/devices/migration`)
            .then((res) => {
                setData(res.data.response);
                toggleLoader(false);
            })
            .catch(err => {
                toggleLoader(false);
                console.log(err);
                toastr.error(t('noMigrations'));
            });
    }

    const timestampFormatter = (cell) => {
        if (cell) {
            return momenttz(cell).format('M/DD/YYYY hh:mm:ss A')
        } else {
            return "-"
        }
    }

    const devicesFormatter = (cell) => {
        return (<CustomButton
            variant="link"
            onClick={() => {
                setSelectRow(cell);
                setShowDevicesModal(true);
            }}>
            {cell.length}
        </CustomButton>)
    }

    const actionFormatter = (cell, row) => {
        return cell.charAt(0).toUpperCase() + cell.slice(1);
    }

    const tableFormatter = (cell) => {
        return cell || '-';
    }

    return (
        <div className="migration-page">
            <main className='main-content-block'>
                <h3 className="category-title">
                    {t('titleMigration')}
                </h3>
                <BootstrapTable
                    data={data}
                    {...tableExportOptions}
                    csvFileName={`${t('titleMigrationDevices') + moment().format('M-D-YY')}.csv`}
                >
                    <TableHeaderColumn
                        width="12%"
                        dataField="init_migrate_ts"
                        dataSort
                        isKey={true}
                        dataFormat={timestampFormatter}
                        csvFormat={timestampFormatter}
                        csvHeader={t('labelDate/Time')}
                    >
                        {t('labelDate/Time')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="15%"
                        dataField="user_email"
                        dataSort
                        csvHeader={t('labelUser')}
                    >
                        {t('labelUser')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="9%"
                        dataField="devices"
                        dataSort
                        tdStyle={{ textAlign: "center" }}
                        dataFormat={devicesFormatter}
                        csvHeader={t('labelDevices')}
                    >
                        {t('labelDevices')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="16%"
                        dataField="target_company_name"
                        tdStyle={{ textAlign: "center" }}
                        dataSort
                        csvHeader={t('labelToCompany')}
                    >
                        {t('labelToCompany')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="16%"
                        dataField="target_company_profile_name"
                        dataFormat={tableFormatter}
                        csvFormat={tableFormatter}
                        tdStyle={{ textAlign: "center" }}
                        dataSort
                        csvHeader={t('labelToProfile')}
                    >
                        {t('labelToProfile')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="16%"
                        dataField="target_device_group_name"
                        dataFormat={tableFormatter}
                        csvFormat={tableFormatter}
                        tdStyle={{ textAlign: "center" }}
                        dataSort
                        csvHeader={t('labelToGroup')}
                    >
                        {t('labelToGroup')}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="16%"
                        dataField="status"
                        dataFormat={actionFormatter}
                        tdStyle={{ textAlign: "center" }}
                        dataSort
                        csvHeader={t('labelStatus')}
                    >
                        {t('labelStatus')}
                    </TableHeaderColumn>
                </BootstrapTable>
            </main>
            {showDevicesModal && (
                <Modal
                    size='xl'
                    show
                    onHide={() => setShowDevicesModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title> {t('titleMigrationDevicesData')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <BootstrapTable
                            data={selectRow}
                            {...tableExportOptions}
                            csvFileName={`${t('textDailyEvents') + moment().format('M-D-YY')}.csv`}
                        >
                            <TableHeaderColumn
                                isKey
                                width="14%"
                                dataField="device_id"
                                dataSort
                                csvHeader={t('labelDeviceId')}
                            >
                                {t('labelDeviceId')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="14%"
                                dataField="vehicle_name"
                                dataSort
                                csvHeader={t('labelVehicleName')}
                            >
                                {t('labelVehicleName')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="14%"
                                dataField="imei"
                                dataFormat={tableFormatter}
                                csvFormat={tableFormatter}
                                tdStyle={{ textAlign: "center" }}
                                dataSort
                                csvHeader={t('labelIMEI')}
                            >
                                {t('labelIMEI')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="16%"
                                dataField="origin_company_name"
                                tdStyle={{ textAlign: "center" }}
                                dataSort
                                csvHeader={t('labelFromCompany')}
                            >
                                {t('labelFromCompany')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="16%"
                                dataField="origin_company_profile_name"
                                dataFormat={tableFormatter}
                                csvFormat={tableFormatter}
                                tdStyle={{ textAlign: "center" }}
                                dataSort
                                csvHeader={t('labelOriginProfileName')}
                            >
                                {t('labelOriginProfileName')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="16%"
                                dataField="origin_device_group_name"
                                dataFormat={tableFormatter}
                                csvFormat={tableFormatter}
                                tdStyle={{ textAlign: "center" }}
                                dataSort
                                csvHeader={t('labelOriginGroupName')}
                            >
                                {t('labelOriginGroupName')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="10%"
                                dataField="status"
                                tdStyle={{ textAlign: "center" }}
                                dataSort
                                csvHeader={t('labelStatus')}
                            >
                                {t('labelStatus')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </Modal.Body>
                </Modal>)}
        </div>
    )
}

export default connect(
    state => ({
        company: state.company.company,
        loader: state.loader.loader
    }),
    dispatch => ({
        toggleLoader: (show) => {
            dispatch({ type: 'TOGGLE_LOADER', payload: show });
        }
    })
)(Migration);
